import React, { useEffect, useState } from 'react';
import AuthLayout from '../../components/layout/AuthLayout';
import Friends from './components/Friends';
import SendInviteToFriend from './components/SendInviteToFriend';
import InviteBox from './components/InviteBox';
import { useFetchReferrals, useRevokeReferral } from '../../hooks/inviteFriends/useInviteFriends';
import { toast } from 'react-toastify';
import { useLogEvent } from '../../hooks/api/post';

function InviteFriends() {
  const [activeTab, setActiveTab] = useState('friends');
  const user = JSON.parse(sessionStorage.getItem('ccAuth'));

  const {
    data: referrals,
    error,
    isError,
    isSuccess,
    refetch,
    isLoading,
  } = useFetchReferrals(user.id);

  const { mutate: logEvent } = useLogEvent();
  const revokeInvite = useRevokeReferral();


  useEffect(() => {
    if (isSuccess && referrals?.data) {
      logEvent({
        userId: user?.id,
        action_type: 'Invite_a_friend_Success',
       // event_description: 'Fetched invited friends list successfully',
       // metadata: { count: referrals?.data?.length || 0 },
      });
    } else if (isError && error?.response) {
      const status = error?.response?.status;
      if (status === 400 || status === 404) {
        logEvent({
          userId: user?.id,
          action_type: 'Invite_a_friend_Failed',
        //  event_description: `Failed to fetch referrals. Status: ${status}`,
         // metadata: { error: error?.response?.data?.message },
        });
      } else if (status === 500) {
        logEvent({
          userId: user?.id,
          action_type: 'Invite_a_friend_Pending',
         // event_description: 'Server error while fetching referrals (500)',
        });
      }
    }
  }, [isSuccess, isError, referrals, error, user?.id, logEvent]);

  const handleRevokeInvite = (referralNumber) => {
    toast.dismiss();
    toast.loading('Revoking invite...');
    revokeInvite.mutate(
      { refferal_phone: referralNumber, user_id: user?.id },
      {
        onSuccess: (data) => {
          toast.dismiss();
          toast.success('Revoke successful');
          refetch();
        },
        onError: (err) => {
          toast.dismiss();
          toast.error('Unable to revoke invite');
        },
      }
    );
  };

  // Copy referral link
  const copyReferralLink = () => {
    const tempInput = document.createElement('input');
    tempInput.value = window.location.origin;
    document.body.appendChild(tempInput);
    tempInput.select();
    try {
      document.execCommand('copy');
      toast.dismiss();
      toast.success('Referral link copied to clipboard!');
    } catch (err) {
      toast.dismiss();
      toast.error('Failed to copy to clipboard');
    }
    document.body.removeChild(tempInput);
  };

  return (
    <AuthLayout>
      <div className="px-4">
        <Friends />

        {/* Tabs */}
        <div className="flex justify-between mt-4">
          <button
            className={`${
              activeTab === 'friends' ? 'bg-[#61A641]' : 'bg-[#c4c4c4]'
            } text-white px-4 py-2 rounded-lg`}
            onClick={() => setActiveTab('friends')}
          >
            Friends
          </button>

          <button
            className={`bg-[#1DD9D9] text-white px-4 py-2 rounded-lg`}
            onClick={copyReferralLink}
          >
            Referral Link
          </button>
        </div>

        {/* Invite Form */}
        <SendInviteToFriend refetch={refetch} />

        {/* Accepted Friends List */}
        {activeTab === 'friends' && (
          <div className="mt-4">
            <h4 className="font-semibold mb-3">Accepted Invites</h4>
            {isLoading ? (
              <p>Loading referrals...</p>
            ) : referrals?.data?.length > 0 ? (
              referrals.data.map((friend, index) => (
                <InviteBox
                  key={index}
                  name={friend?.refferal_phone}
                  buttonLabel="Revoke"
                  buttonColor="#F24444"
                  buttonFunction={() => handleRevokeInvite(friend?.refferal_phone)}
                />
              ))
            ) : (
              <p className="text-gray-500">No accepted invites yet.</p>
            )}
          </div>
        )}
      </div>
    </AuthLayout>
  );
}

export default InviteFriends;
